import { network } from 'services/network';

import { QueryParams } from 'api/queries/getWbs.query';

export const getActivityCodesByVersion = ({ latestVersion }: Pick<QueryParams, 'latestVersion'>) => {
    const url = `api/bo/getActivityCodesByVersion?versionId=${latestVersion}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
